/**
 * Merge given object properties into comma separated string while replacing the original array
 *
 * @param {string} collection
 * @param {string} name
 * @param {Array<Object>} data
 */

export default function joinColumnValues(collection: string, name: string, data: Array<Object>) {

    data.forEach((object: Object, index: number, data: Array<Object>) => {

        let joinValues: Array<string> = [];

        data[index][collection].forEach((item: Object) => {

            joinValues.push(item[name]);
        });
        data[index][collection] = joinValues;
    });
}
